var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"submenu-item"}},_vm._l((_vm.items),function(item,index){return _c('router-link',{key:index,staticClass:"item",attrs:{"to":item.route}},[_vm._v(_vm._s(item.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }